<template>
  <lottie :options="defaultOptions" :height="200" :width="200" />
</template>
<script>
import Lottie from "vue-lottie";
import * as animationData from "@/assets/animations/dental_loader.js";
export default {
  components: {
    Lottie
  },
  data() {
    return {
      defaultOptions: { animationData: animationData.default, loop: true },
      animationSpeed: 1
    };
  }
};
</script>
